import React from 'react';
import classNames from 'classnames';

import Text from '../text/Text';

export interface ProgressBarProps {
  testId?: string;
  type?:
    | 'primary'
    | 'danger'
    | 'success'
    | 'secondary'
    | 'warning'
    | 'info'
    | 'dark';
  progress?: number;
  size?: 'lg' | 'md' | 'sm';
  showProgressNumber?: boolean;
}

const ProgressBar = ({
  testId,
  type = 'danger',
  progress = 0,
  size = 'sm',
  showProgressNumber,
}: ProgressBarProps) => {
  const currentProgress = progress < 0 ? 0 : progress > 100 ? 100 : progress;

  return (
    <div
      data-testid={testId}
      className="d-flex justify-content-center align-items-center w-100 gap-2"
      role="progressbar"
      aria-valuenow={currentProgress}
    >
      <div
        className={classNames(
          'progress-bar',
          'rounded-pill',
          'position-relative',
          'd-inline-block',
          'w-100',
          { [`progress-bar-${size}`]: size },
        )}
      >
        <div
          className={classNames('position-relative', 'rounded-pill', 'h-100', {
            [`bg-${type}`]: type,
          })}
          style={{ width: `${currentProgress}%` }}
        />
      </div>

      {showProgressNumber ? (
        <Text className="text-nowrap">{currentProgress} %</Text>
      ) : null}
    </div>
  );
};

export default ProgressBar;
